module.exports = __webpack_public_path__ + "img/kelly-sikkema-3-Tc_5LROrM-unsplash.190009a7.jpg";